module.exports = __webpack_public_path__ + "static/img/icon9.12fec34.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/fxcp_result/images/icon9.png
// module id = IGlA
// module chunks = 21